import React, { useEffect, useState } from 'react';
import httpService from "../../services/httpService";
import Spinner from 'react-bootstrap/Spinner';
import Alert from 'react-bootstrap/Alert';
import Image from "react-bootstrap/Image";
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import Fade from 'react-bootstrap/Fade';
import { FaUser, FaBolt, FaAddressBook, FaChartBar, FaComments } from 'react-icons/fa';
import ChatThread from '../Chat/ChatThread';

const UserInfo = ({ userGuid, clubGuid, context }) => {
    const [loading, setLoading] = useState(true);
    const [userInfo, setUserInfo] = useState(null);
    const [listenerInfo, setListenerInfo] = useState(null);
    const [stats, setStats] = useState(null);
    const [error, setError] = useState(null);
    const [activeTab, setActiveTab] = useState('info');

    useEffect(() => {
        if (userGuid && context) {
            fetchUserInfo();
        }
    }, [userGuid, context]);

    const fetchUserInfo = () => {
        setLoading(true);
        setError(null);

        // Build the API endpoint based on context
        let endpoint = `/dash/user/${userGuid}/info?type=${context.type}`;
        if(context.data.resource){
            endpoint+='&resource='+context.data.resource
        }
        if(context.data.guid){
            endpoint+='&guid='+context.data.guid
        }

        httpService.get(endpoint)
            .then((res) => {
                setUserInfo(res.data.data.user || null);
                setListenerInfo(res.data.data.listener || null);
                setStats(res.data.data.stats || null);
            })
            .catch((err) => {
                setError(err.response?.data?.message || "Error loading user info");
            })
            .finally(() => setLoading(false));
    };

    if (loading) {
        return (
            <div className="text-center py-4">
                <Spinner animation="border" role="status" size="sm">
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
                <p className="mt-2 small text-muted">Loading user info...</p>
            </div>
        );
    }

    if (error) {
        return (
            <Alert variant="danger">
                {error}
            </Alert>
        );
    }

    if (!userInfo) {
        return (
            <Alert variant="info">
                No user information available.
            </Alert>
        );
    }

    return (
        <Fade in={true} appear={true}>
            <div className="py-1">
                <Image fluid src={'/img/person-wide.jpg'} className="mb-0" />
                <Image
                    className="user_avatar"
                    src={`${process.env.REACT_APP_API_URL}/storage/avatars/${userInfo.guid}.png`}
                    style={{
                        width: '60px',
                        height: '60px',
                        objectFit: 'cover',
                        borderRadius: '50%',
                        marginTop: '-70px',
                        marginBottom: '0px',
                        marginLeft: '10px',
                        border: '3px solid white',
                        boxShadow: '0 0px 10px rgba(0,0,0,0.2)'
                    }}
                />
                <Tabs
                    activeKey={activeTab}
                    onSelect={(k) => setActiveTab(k)}
                    className="mb-3"
                >
                    <Tab eventKey="info" title={<span><FaUser className="me-1" />Info</span>}>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="mb-3">
                                </div>
                                <div className="mb-3">
                                    <label className="text-muted small">Name</label>
                                    <p className="mb-0">{userInfo.first_name} {userInfo.last_name}</p>
                                </div>
                                <div className="mb-3">
                                    <label className="text-muted small">Email</label>
                                    <p className="mb-0">{userInfo.email}</p>
                                </div>
                            </div>
                            <div className="col-md-6">
                                {userInfo.joined_date && (
                                    <div className="mb-3">
                                        <label className="text-muted small">Member Since</label>
                                        <p className="mb-0">{new Date(userInfo.joined_date).toLocaleDateString('en-US', {
                                            month: 'long',
                                            day: 'numeric',
                                            year: 'numeric'
                                        })}</p>
                                    </div>
                                )}
                                {userInfo.total_practices !== undefined && (
                                    <div className="mb-3">
                                        <label className="text-muted small">Total Practices</label>
                                        <p className="mb-0">{userInfo.total_practices}</p>
                                    </div>
                                )}
                            </div>
                        </div>
                    </Tab>

                    {/*<Tab eventKey="activity" title={<span><FaBolt className="me-1" />Activity</span>}>*/}
                    {/*    <div className="py-3 text-center text-muted">*/}
                    {/*        <p>Recent activity will be displayed here</p>*/}
                    {/*    </div>*/}
                    {/*</Tab>*/}

                    <Tab eventKey="contacts" title={<span><FaAddressBook className="me-1" />Contacts</span>}>
                        <div className="py-3 text-center text-muted">
                            <p>Contact information will be displayed here</p>
                        </div>
                    </Tab>

                    <Tab eventKey="stats" title={<span><FaChartBar className="me-1" />Stats</span>}>
                        {stats ? (
                            <div className="py-3">
                                <div className="row g-3">
                                    <div className="col-6 col-md-3">
                                        <div className="border rounded p-3 text-center">
                                            <div className="fs-3 fw-bold">{stats.practices?.total ?? 0}</div>
                                            <div className="text-muted small">Practices Created</div>
                                        </div>
                                    </div>
                                    <div className="col-6 col-md-3">
                                        <div className="border rounded p-3 text-center">
                                            <div className="fs-3 fw-bold">{stats.practices?.completed ?? 0}</div>
                                            <div className="text-muted small">Practices Completed</div>
                                        </div>
                                    </div>
                                    <div className="col-6 col-md-3">
                                        <div className="border rounded p-3 text-center">
                                            <div className="fs-3 fw-bold">{stats.comments?.total ?? 0}</div>
                                            <div className="text-muted small">Comments</div>
                                        </div>
                                    </div>
                                    <div className="col-6 col-md-3">
                                        <div className="border rounded p-3 text-center">
                                            <div className="fs-3 fw-bold">{stats.reactions_received?.total ?? 0}</div>
                                            <div className="text-muted small">Reactions Received</div>
                                        </div>
                                    </div>
                                    <div className="col-6 col-md-3">
                                        <div className="border rounded p-3 text-center">
                                            <div className="fs-3 fw-bold">{stats.reactions_given?.total ?? 0}</div>
                                            <div className="text-muted small">Reactions Given</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="py-3 text-center text-muted">
                                <p>No statistics available</p>
                            </div>
                        )}
                    </Tab>
                    <Tab eventKey="chat" title={<span><FaComments className="me-1" />Chat</span>}>
                        {activeTab === 'chat' && (
                            listenerInfo?.guid
                                ? <ChatThread
                                    clubGuid={clubGuid}
                                    listenerGuid={listenerInfo.guid}
                                    userInfoGuid={userInfo.guid}
                                    participant={{
                                        first_name: userInfo.first_name,
                                        last_name:  userInfo.last_name,
                                        avatar_url: userInfo.avatar_url ?? null,
                                    }}
                                    userType="podcaster"
                                  />
                                : <div className="py-3 text-center text-muted small">
                                    This user does not have a listener profile.
                                  </div>
                        )}
                    </Tab>
                </Tabs>
            </div>
        </Fade>
    );
};

export default UserInfo;